export default __webpack_public_path__ + "static/media/gift-large-arrow.483754d8.svg";